import { render } from "./MinesTile.vue?vue&type=template&id=1e6c9216&scoped=true"
import script from "./MinesTile.vue?vue&type=script&lang=js"
export * from "./MinesTile.vue?vue&type=script&lang=js"

import "./MinesTile.vue?vue&type=style&index=0&id=1e6c9216&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6c9216"]])

export default __exports__